import React from 'react';
import { connect } from 'react-redux';
import * as path from '../../../route/PathConfig';
import ReNavigationBar from '../navigation-bar/ReNavigationBar';
import Linker from '../linker/Linker';
import DropdownUser from '../../container/dropdown/dropdown-user/DropdownUser';
import './Header.css';

const Header = (props) => {
  return (
    <div id="header">
      <h1 className="logo">
        <Linker path={path.HOME}>
          <a href={path.HOME} title="Nielsen">Nielsen Korea</a>
        </Linker>
        </h1>
      <ReNavigationBar path={path} currentRole={props.currentRole}/>
        {props.currentUser==='' || props.currentUser==undefined ? 
          <div className="headerRight">
            <Linker path={path.LOGIN}>
              <a className="button purple">로그인</a>
            </Linker>
          </div>
          :<DropdownUser email={props.currentUser} />
        }
    </div>
  )
}

const mapStateToProps = (state) => ({
  currentUser: state.AuthManager.status.currentUser,
  currentRole: state.AuthManager.status.currentRole
});
export default connect(mapStateToProps) (Header);